import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/Kimu-Japanese-Cuisine-1807394236197836/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Yanaki Sushi Facebook"
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/yanaki_sushi_6ave/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Yanaki Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/Kimu-Japanese-Cuisine-1807394236197836/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Yanaki Sushi Facebook"
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/yanaki_sushi_6ave/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Yanaki Sushi Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
